import { render } from "./sales-report.vue?vue&type=template&id=09534db6&scoped=true"
import script from "./sales-report.vue?vue&type=script&lang=js"
export * from "./sales-report.vue?vue&type=script&lang=js"

import "./sales-report.vue?vue&type=style&index=0&id=09534db6&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09534db6"]])

export default __exports__